var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevelopmentalStage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.43652 2.85938L2.1416 0.919922C1.85449 0.486328 2.0127 0 2.53418 0H5.31738C5.85645 0 6.02637 0.46875 5.72168 0.919922L4.39746 2.85938C4.16895 3.19336 3.6709 3.20508 3.43652 2.85938ZM0.0761205 6.61732C0 6.80109 0 7.03406 0 7.5C0 7.96594 0 8.19891 0.0761205 8.38268C0.177614 8.62771 0.372288 8.82239 0.617317 8.92388C0.801088 9 1.03406 9 1.5 9H3V10C3 10.5523 3.44772 11 4 11C4.55228 11 5 10.5523 5 10V9H12.5C12.9659 9 13.1989 9 13.3827 8.92388C13.6277 8.82239 13.8224 8.62771 13.9239 8.38268C14 8.19891 14 7.96594 14 7.5C14 7.03406 14 6.80109 13.9239 6.61732C13.8224 6.37229 13.6277 6.17761 13.3827 6.07612C13.1989 6 12.9659 6 12.5 6H5V5C5 4.44772 4.55228 4 4 4C3.44772 4 3 4.44772 3 5V6H1.5C1.03406 6 0.801088 6 0.617317 6.07612C0.372288 6.17761 0.177614 6.37229 0.0761205 6.61732ZM1.5 7C1.22386 7 1 7.22386 1 7.5C1 7.77614 1.22386 8 1.5 8C1.77614 8 2 7.77614 2 7.5C2 7.22386 1.77614 7 1.5 7ZM12 7.5C12 7.22386 12.2239 7 12.5 7C12.7761 7 13 7.22386 13 7.5C13 7.77614 12.7761 8 12.5 8C12.2239 8 12 7.77614 12 7.5ZM8.1416 0.919922L9.43652 2.85938C9.6709 3.20508 10.1689 3.19336 10.3975 2.85938L11.7217 0.919922C12.0264 0.46875 11.8564 0 11.3174 0H8.53418C8.0127 0 7.85449 0.486328 8.1416 0.919922Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevelopmentalStage);
export default __webpack_public_path__ + "static/media/developmental-stage.3bd3e6238bbe72abefe65fdf4b692090.svg";
export { ForwardRef as ReactComponent };